import { useEffect, useRef } from "react";
import useToast from "../../hooks/useToast";
import useAuth from "../../hooks/useAuth"; 
import useNetworkStatus from "../../hooks/useNetworkStatus";
import { ReactComponent as OfflineIcon } from "../../assets/icons/Offline.svg";
import { ReactComponent as OnlineIcon } from "../../assets/icons/Online.svg";

const DEFAULT_OFFLINE_DURATION = 4000;
const DEFAULT_ONLINE_DURATION = 3000;

const NetworkStatusToastTrigger = () => {
  const { isOnline } = useNetworkStatus();
  const toast = useToast();
  const wasOnline = useRef(isOnline);
  const { isLogged } = useAuth();

  useEffect(() => {
    // only trigger if the user is logged in
    if (!isLogged) return;

    if (wasOnline.current !== isOnline) {
      if (!isOnline) {
        toast.triggerToast({
          type: "info",
          primaryMessage: "You are offline",
          secondaryMessage: "Check your connection for full access to features.",
          icon: OfflineIcon,
          autoHideDuration: DEFAULT_OFFLINE_DURATION,
        });
      } else {
        toast.triggerToast({
          type: "info",
          primaryMessage: "You are back online",
          secondaryMessage: "Full access to features restored.",
          icon: OnlineIcon,
          autoHideDuration: DEFAULT_ONLINE_DURATION,
        });
      }
      wasOnline.current = isOnline;
    }
  }, [isOnline, toast, isLogged]);

  return null;
};

export default NetworkStatusToastTrigger;